import { NavLink, Outlet } from 'react-router';
import { BRAND } from '@teachpartner/config/brand';
import { useServices } from '../app-context';

export function Layout() {
  const { user, auth } = useServices();
  return (
    <div className="shell">
      <header className="topbar">
        <span className="brand">
          <img className="brand-icon" src="/favicon.svg" alt="" width={28} height={28} />
          <strong>{BRAND.displayName} · Host Admin</strong>
        </span>
        <nav aria-label="Main">
          <NavLink to="/" end>
            Tenants
          </NavLink>
          <NavLink to="/push">Push stats</NavLink>
          <NavLink to="/audit">Audit log</NavLink>
          <NavLink to="/updates">Updates</NavLink>
        </nav>
        <span className="user">
          {user.email}
          <button type="button" className="link" onClick={() => void auth.signOut()}>
            Sign out
          </button>
        </span>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
